// extracted by mini-css-extract-plugin
module.exports = {"audio":"audio_audio__2FFl6","audioWrapper":"audio_audioWrapper__bUbZY","iframe":"audio_iframe__1QnAO"};